import React from 'react'
import { TransProps as NextTransProps } from 'react-i18next'
import { Trans as NextTrans } from 'next-i18next'
import { getTranslationKeys } from '../../utils/convergence'
import { useCohort } from '../../state'

type TransProps = Omit<NextTransProps<string>, 'i18nKey' | 'context' | 'defaults'> & {
  i18nKey: string | string[]
  context?: string
  defaults?: string
}

// Note: this custom Trans component generate additional translation key for convergence
// If you need to use diff copy for Cohort.CashOnly, for eg: summary__cash.json, please use this component

export const Trans = ({ i18nKey, ...otherProps }: TransProps): React.ReactElement => {
  const cohort = useCohort()
  const convergenceKeys = getTranslationKeys(i18nKey, cohort)

  return <NextTrans {...otherProps} i18nKey={convergenceKeys} />
}
